module.exports = __webpack_public_path__ + "img/ci.f93d7575.svg";